import { render, staticRenderFns } from "./TestApi.vue?vue&type=template&id=cdfcc902&scoped=true&"
import script from "./TestApi.vue?vue&type=script&lang=js&"
export * from "./TestApi.vue?vue&type=script&lang=js&"
import style0 from "./TestApi.vue?vue&type=style&index=0&id=cdfcc902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfcc902",
  null
  
)

export default component.exports